import type { BracketSportGroup } from "@/domain/bracket/model/Bracket"

/**
 * 종목별로 묶는다.
 *
 * 경기 번호가 종목마다 1부터라 종목이 섞인 목록을 그대로 그리면 같은 번호가 여러 번 나온다 —
 * 화면은 종목 묶음마다 제목을 달아 그린다.
 * 서버가 종목 코드 순으로 내려주므로 처음 나온 순서를 그대로 지킨다.
 */
function groupBySport<T extends { sportLabel: string }>(
  items: T[],
): BracketSportGroup<T>[] {
  const itemsBySport = new Map<string, T[]>()

  items.forEach((item) => {
    const sportItems = itemsBySport.get(item.sportLabel) ?? []

    sportItems.push(item)
    itemsBySport.set(item.sportLabel, sportItems)
  })

  return Array.from(itemsBySport, ([sportLabel, sportItems]) => ({
    sportLabel,
    items: sportItems,
  }))
}

export { groupBySport }
